// Acceso diferido al cliente de backend del navegador.
//
// PERF: los archivos de ruta de TanStack Start se empaquetan en el chunk de
// entrada, así que un `import { supabase } from "@/integrations/supabase/client"`
// en ámbito de módulo mete todo el SDK (~700 kB de fuente) en la primera carga.
// Con este helper el SDK se descarga sólo cuando alguna interacción lo necesita.
export function getSupabase() {
  return import("@/integrations/supabase/client").then((m) => m.supabase);
}
